module.exports = __webpack_public_path__ + "media/images/bg/mosaic/conversation-ee469095ffd12cc70e026e2cd168c30c.svg";